import React from "react";
import {AtendimentosSSEService} from "../services";
import {ReportWrapper} from "../components/ReportsWrapper";
import GerencialTable from "../components/Reports/content/Table/components/Tables/GerencialTable";
import AgenteTable from "../components/Reports/content/Table/components/Tables/AgenteTable";
import ConsolidadoTable from "../components/Reports/content/Table/components/Tables/ConsolidadoTable";
import DescartadosTable from "../components/Reports/content/Table/components/Tables/DescartadosTable";
import TestadoresTable from "../components/Reports/content/Table/components/Tables/TestadoresTable";
import RecusaramTable from "../components/Reports/content/Table/components/Tables/RecusaramTable";

export const AtendimentosSala = () => {
    return (
        <ReportWrapper
            title="Atendimentos Sala"
            service={AtendimentosSSEService}
            queryKey="filtrosAtendimentoSala"
            tipoAtendimento="SALA_EMPREENDEDOR"
            exportFilenamePrefix="Exportacao_Atendimentos_Sala"
            tabs={[
                { id: "gerencial", label: "Gerencial", component: GerencialTable },
                { id: "por-agente", label: "Por Agente", component: AgenteTable },
                { id: "consolidado", label: "Consolidado", component: ConsolidadoTable },
                { id: "descartados", label: "Descartados", component: DescartadosTable },
                { id: "testadores", label: "Testadores", component: TestadoresTable },
                { id: "recusaram", label: "Recusaram", component: RecusaramTable },
            ]}
        />
    );
};
